/**
 * Stable CSS class names for E2E / automation on Cargo Company Distribution Areas.
 * Combine layout sections with `cargo-company-distribution-areas-input--{kind}` on interactive controls.
 */
export const CCDA = {
    page: 'cargo-company-distribution-areas-page',
    paper: 'cargo-company-distribution-areas-page__paper',
    toolbar: 'cargo-company-distribution-areas-page__toolbar',
    datagrid: 'cargo-company-distribution-areas-page__datagrid',
    emptyState: 'cargo-company-distribution-areas-page__empty-state',

    drawer: 'cargo-company-distribution-areas-drawer',
    drawerBody: 'cargo-company-distribution-areas-drawer__body',
    drawerForm: 'cargo-company-distribution-areas-drawer__form',
    drawerActions: 'cargo-company-distribution-areas-drawer__actions',

    input: 'cargo-company-distribution-areas-input',
    inputButton: 'cargo-company-distribution-areas-input--button',
    inputAutocomplete: 'cargo-company-distribution-areas-input--autocomplete',
    inputTextfield: 'cargo-company-distribution-areas-input--textfield',

    fieldCargoCompany: 'cargo-company-distribution-areas-field--cargo-company',
    fieldCity: 'cargo-company-distribution-areas-field--city',
    fieldCounty: 'cargo-company-distribution-areas-field--county',
    fieldDistributionType: 'cargo-company-distribution-areas-field--distribution-type',

    btnExportExcel: 'cargo-company-distribution-areas-field--export-excel',
    btnOpenSearch: 'cargo-company-distribution-areas-field--open-search',
    btnEmptySearch: 'cargo-company-distribution-areas-field--empty-search',
    btnDrawerClear: 'cargo-company-distribution-areas-field--drawer-clear',
    btnDrawerSubmit: 'cargo-company-distribution-areas-field--drawer-submit',
} as const;

export const ccdaCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
